module.exports = __webpack_public_path__ + "img/donation.a23e7dc2.jpg";